import {ApiException} from "@/services/BackendProxies";
import 'jquery-toast-plugin/dist/jquery.toast.min'
import 'jquery-toast-plugin/dist/jquery.toast.min.css'
import Component from "vue-class-component";
import $ from "jquery";
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import translations from '../i18n/messages'
import storage from '@/services/local-storage.service'

@Component
export class ComponentBaseMixin extends Vue {

    async confirmationNeeded(message: string) {
        const { value } = await this.$swal({type: 'question',
            title: <string>this.$i18n.t('potvrda'),
            text: <string>this.$i18n.t(message),
            cancelButtonText: <string>this.$i18n.t('ne'),
            confirmButtonText: <string>this.$i18n.t('da'),
            showCancelButton: true
        });
        return value || false;
    }

    showInfo(message: string) {
        const translator = this.getTranslator();
        const title = <string>(translator).t('informacija');
        const msg = <string>translator.t(message);

        $.toast({heading: title,
            text: msg,
            position:"top-right",
            loaderBg:"#3b98b5",
            icon:"info",
            hideAfter:3e3,
            stack:1
        });
    }

    showError(message: string) {
        const translator = this.getTranslator();
        const title = <string>(translator).t('greska');
        const msg = <string>translator.t(message);

        $.toast({heading: title,
            text: msg,
            position:"top-right",
            loaderBg:"#bf441d",
            icon:"error",
            hideAfter:3e3,
            stack: 5
        });
    }

    saveData<TResult>(handler: (...params: any) => Promise<TResult>): () => Promise<TResult> {
        return this.callService(handler, {
            successMessage: <string>this.$i18n.t('podaciSuUspecnoSacuvani'),
            errorMessage: <string>this.$i18n.t('nesupesnoCuvanjePodataka')}
        );
    }

    loadData<TResult>(handler: (...params: any) => Promise<TResult>): () => Promise<TResult> {
        return this.callService(handler, {errorMessage: <string>this.$i18n.t('neuspesnoUcitavanjePodataka')})
    }

    deleteData<TResult>(handler: (...params: any) => Promise<TResult>): () => Promise<TResult> {
        return this.callService(handler, {
            successMessage: <string>this.$i18n.t('uspesnoBrisanjePodataka'),
            errorMessage: <string>this.$i18n.t('neuspesnoBrisanjePodataka')
        });
    }

    callService<TResult>(handler: (...params: any) => Promise<TResult>, messages?: {successMessage?: string, errorMessage?: string}): () => Promise<TResult> {
        return async (...params: any) => {
            try {
               const result = await handler(params);
               if (messages && messages.successMessage) {
                   this.showInfo(messages.successMessage);
               }
               return result;
            } catch (e) {
                console.error('Error received', e);
                this.processException(e);
                throw e;
            }
        };
    }

    processException(e: ApiException | string) {
        if (typeof e == "string") {
            this.showError(this.$i18n ? <string>this.$i18n.t(<string>e) : e);
            return;
        }
        if (e.status == 401) {
            this.showError('unauthorized');
            setTimeout(() => {
                this.$router.push('/login');
            }, 3e3);
        } else {
            this.showError(e.message);
        }
    }

    private getTranslator() {
        return this.$i18n || new VueI18n({
            messages: translations,
            locale: <string>storage.get('language') || 'rs'
        });
    }
}
